import { Radio } from 'antd';
import { get } from 'lodash';
import React, { useCallback, useMemo, useRef } from 'react';
import styled from 'styled-components';

import { ICommonInputProps } from './types';

const RadioStyled = styled(Radio)`
  display: block;
`;

const RadioTabStyled = styled.div<{ $isSelected: boolean }>`
  padding: 5px;
  position: relative;
  padding-right: 10px;
  padding-left: 10px;
  ${({ $isSelected }) => ($isSelected ? 'color: #038fde; font-weight: 500' : '')};
`;

const RadioButtonStyled = styled(Radio.Button)``;
const RadioGroupStyled = styled(Radio.Group)<{ $rowDisplay?: boolean }>`
  ${({ $rowDisplay }) => ($rowDisplay ? 'display: flex;' : '')}
  & .radio-item:not(:first-child) {
    margin-top: ${({ $rowDisplay }) => ($rowDisplay ? '0' : '12px')};
  }
`;

const RadioInput: React.FC<ICommonInputProps> = ({
  disabled,
  name,
  defaultValue,
  inputClassName,
  onChange,
  value,
  inputOptions,
  inputSettings,
}) => {
  const tabRef = useRef<Record<string, number>>({});
  const tabIndexRef = useRef<Record<string, any>>({});
  const handleChange = useCallback(
    (e: any) => {
      let currentValue = e;
      if (typeof e === 'object') currentValue = get(e, 'target.value', '');
      onChange?.(currentValue);
    },
    [onChange],
  );

  const RadioParentComponent = useMemo(
    () => (inputSettings?.buttonStyle === 'solid' ? RadioButtonStyled : RadioStyled),
    [inputSettings?.buttonStyle],
  );

  const generateRadioOptions = (opt: any) => (
    <RadioParentComponent className='radio-item' disabled={opt?.disabled} key={opt.value} value={opt.value}>
      {opt.label}
    </RadioParentComponent>
  );
  const currentTabIndex = tabIndexRef.current?.[value] || 0;
  const currentTabWidth = tabRef.current?.[value] || 0;
  const currentUnderlineIndicatorLeftPos: number =
    Object.values(tabRef.current).reduce((acc, tabWidth, i) => {
      let res = acc;
      if (currentTabIndex && i < currentTabIndex) {
        res += tabWidth || 0;
      }
      return res;
    }, 0) || 0;
  return (
    <>
      <RadioGroupStyled
        disabled={disabled}
        className={`radio-input ${inputClassName} ${inputSettings?.radioStyle === 'tab' ? '!hidden' : ''}`}
        name={name}
        defaultValue={defaultValue}
        onChange={handleChange}
        $rowDisplay={inputSettings?.rowDisplay || inputSettings?.buttonStyle === 'solid'}
        buttonStyle='solid'
        value={value}
        {...(inputSettings || {})}>
        {inputOptions && inputOptions.map(generateRadioOptions)}
      </RadioGroupStyled>
      {inputSettings?.radioStyle === 'tab' && (
        <div className='relative flex'>
          <div
            className='absolute top-0  h-full border-b border-primary-color transition-all'
            style={{ width: currentTabWidth, left: currentUnderlineIndicatorLeftPos || 0 }}
          />
          {inputOptions?.map((opt, i) => (
            <RadioTabStyled
              className='cursor-pointer'
              ref={(ref) => {
                tabRef.current[opt.value] = ref?.offsetWidth || 0;
                tabIndexRef.current[opt.value] = i;
              }}
              $isSelected={opt.value === value}
              key={opt.value}
              onClick={() => {
                handleChange(opt.value);
              }}>
              {opt.label}
            </RadioTabStyled>
          ))}
        </div>
        // <Tabs onChange={(k) => handleChange(k)} activeKey={value}>
        //   {inputOptions?.map((opt) => (
        //     <TabPane key={opt.value}>{opt.label}</TabPane>
        //   ))}
        // </Tabs>
      )}
    </>
  );
};

export default React.memo(RadioInput);
